import { css, type KivraCSSObject } from "../../theme/styled";

export type CardVariants =
  | "Neutral"
  | "Plain"
  | "Raised"
  | "Floating"
  | "Selected";

export type CardHoverVariants = "ToFloating" | "ToSelected";

const CardDefaultStyles: KivraCSSObject = {
  display: "block",
  borderRadius: "$radius-medium",
  transition: "all 0.25s cubic-bezier(0.35, 0.35, 0.58, 1) 0s",
  border: "1px solid transparent",
};

const CardVariantNeutral = css({
  ...CardDefaultStyles,
  background: "$surface-neutral",
});

const CardVariantPlain = css({
  ...CardDefaultStyles,
  backgroundColor: "$background-secondary",
  border: "1px solid $border-subtle",
});

const CardVariantRaised = css({
  ...CardDefaultStyles,
  backgroundColor: "$background-secondary",
  border: "1px solid $border-subtle",
  boxShadow: "$shadow-raised",
});

const CardVariantFloating = css({
  ...CardDefaultStyles,
  backgroundColor: "$background-secondary",
  border: "1px solid $border-subtle",
  boxShadow: "$shadow-floating",
});

const CardVariantSelected = css({
  ...CardDefaultStyles,
  backgroundColor: "$background-secondary",
  border: "1px solid $active-highlight",
});

const CardHoverToFloating = css({
  "&:hover": {
    transform: "translate3d(0px, -2px, 0px)",
    boxShadow: "$shadow-floating",
  },
});

const CardHoverToSelected = css({
  "&:hover": {
    border: "1px solid $active-highlight",
  },
});

const CardIsSmall = css({
  padding: "$spacing-16",
});

const CardIsMedium = css({
  padding: "$spacing-24",
});

const CardIsLarge = css({
  padding: "$spacing-32",
});

export const Card = {
  Variant: {
    Neutral: CardVariantNeutral,
    Plain: CardVariantPlain,
    Raised: CardVariantRaised,
    Floating: CardVariantFloating,
    Selected: CardVariantSelected,
  },
  Hover: {
    ToFloating: CardHoverToFloating,
    ToSelected: CardHoverToSelected,
  },
  Size: {
    Small: CardIsSmall,
    Medium: CardIsMedium,
    Large: CardIsLarge,
  },
};
